import {Image} from "react-bootstrap";
import {Link} from "react-router-dom";

function ProfileIcon({username, profile_picture_url, firstname, lastname, title}) {
    return (
        <div>
            <Link to={"/users/" + username + "/profile"}
                  style={{color: "white", textUnderline: "white"}}>
                <Image className="rounded-circle ratio ratio-1x1" src={profile_picture_url} style={{aspectRatio:"1/1"}}/>
                <div className="gap-0">
                    <p className=" mt-2 mb-0 p-0">{firstname} {lastname}</p>
                    <p className="">{title}</p>
                </div>
            </Link>
        </div>
    );
}

export default ProfileIcon;